import React from 'react'

const RatesPage = () => {
  return (
    <div>RatesPage</div>
  )
}

export default RatesPage;